export const API_URL = "https://vims-api.outcondev.com";
export const API_PATH = "/api/v1/";
export const GOOGLE_CLIENT_ID = "15549080301-nvmogq514rthu9s47knft5atfk193787.apps.googleusercontent.com";

export var OauthClient = (grant, params) => {
    var clientData = {
        grant_type: grant,
        client_id: 2,
        client_secret: "21tTtkabnOlBtdMza0Kn54WMNbHlE944LPuuyaPP",
        scope: "*"
    };

    if (params && typeof params === "object") {
        clientData = Object.assign(clientData, params);
    }

    return clientData;
};

export const COPPER_NEW_CONTACT =
    "https://app.prosperworks.com/companies/160998/app?p=db#/contacts/default";

export default API_URL;
